export default function($) {
  var bottomCats = $('.js-cat-dropdown'),
      button = $('.js-expand-cat-dropdown'),
      moreText = button.data('more'),
      lessText = button.data('less'),
      isOpen = false;

  button.on('click', function() {
    if( !isOpen ) {
      bottomCats.removeClass('hidden');
      bottomCats.addClass('flex');
      $(this).find('.button-label').text(lessText);
      $(this).find('svg').css('transform', 'rotate(180deg)');
      isOpen = true;
    } else {
      bottomCats.removeClass('flex');
      bottomCats.addClass('hidden');
      $(this).find('.button-label').text(moreText);
      $(this).find('svg').css('transform', 'rotate(0)');
      isOpen = false;
    }
  })
}
